import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi } from "./api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      setMe(data);
    } catch {
      setTimeout(refresh, 2000);
    }
  }, [api]);
  useEffect(() => { refresh(); }, [refresh]);
  if (!me) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
        <span className="mono-label animate-pulse">Tuning up…</span>
      </div>
    );
  }
  const isStaff = me.role === "admin" || me.role === "host";
  return <MeCtx.Provider value={{ me, refresh, isStaff, isAdmin: me.role === "admin" }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
